"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CountMetric: function() {
        return _types.CountMetric;
    },
    SummaryMetric: function() {
        return _types.SummaryMetric;
    },
    reportErrorToServer: function() {
        return _reportErrorToServer.reportErrorToServer;
    },
    TelemetryErrorOptions: function() {
        return _types.TelemetryErrorOptions;
    },
    telemetry: function() {
        return telemetry;
    }
});
const _types = require("./types");
const _reportErrorToServer = require("./reportErrorToServer");
let Telemetry = class Telemetry {
    // Flushes the metrics buffer by sending the data to the telemetry endpoint.
    async sendBufferedMetrics() {
        if (this.metricsBuffer.length === 0) {
            return;
        }
        const metricsToSend = [
            ...this.metricsBuffer
        ];
        this.metricsBuffer.length = 0;
        try {
            const response = await fetch('/_/fe_telemetry', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(metricsToSend)
            });
            if (!response.ok) {
                // If the request fails, we log it and queue the metrics back.
                this.queueMetrics(metricsToSend);
            }
        } catch (e) {
            console.error(e, 'Failed to send frontend metrics:', metricsToSend);
            this.queueMetrics(metricsToSend);
        }
    }
    queueMetric(metric) {
        this.queueMetrics([
            metric
        ]);
    }
    queueMetrics(metrics) {
        for (const m of metrics){
            if (this.metricsBuffer.length >= Telemetry.MAX_BUFFER_SIZE) {
                console.warn('Frontend metrics buffer full, removing oldest metric to make space.');
                this.metricsBuffer.shift(); // Remove the oldest metric (FIFO)
            }
            this.metricsBuffer.push(m);
        }
        if (!this.timerId) {
            this.timerId = window.setTimeout(()=>{
                this.sendBufferedMetrics();
                this.timerId = null;
            }, Telemetry.BUFFER_FLUSH_INTERVAL_MS);
        }
    }
    increaseCounter(metricName, tags = {}) {
        this.queueMetric({
            metric_name: metricName,
            metric_value: 1,
            tags: tags,
            metric_type: 'counter'
        });
    }
    recordSummary(metricName, val, tags = {}) {
        this.queueMetric({
            metric_name: metricName,
            metric_value: val,
            tags: tags,
            metric_type: 'summary'
        });
    }
    /**
   * Reports an error message to the server.
   * This is a pass-through to the reportErrorToServer function.
   */ reportErrorToServer(errorBody, options = {}) {
        return (0, _reportErrorToServer.reportErrorToServer)(errorBody, options);
    }
    constructor(){
        this.metricsBuffer = [];
        this.timerId = null;
        // The following are exposed for testing purposes.
        this._forTesting = {
            reset: ()=>{
                this.metricsBuffer.length = 0;
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                }
            },
            getBuffer: ()=>this.metricsBuffer,
            MAX_BUFFER_SIZE: Telemetry.MAX_BUFFER_SIZE
        };
        // When the page visibility changes, flush the buffer. This helps ensure we
        // capture metrics before the user navigates away or closes the tab.
        document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'hidden') {
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                }
                this.sendBufferedMetrics();
            }
        });
    }
};
(()=>{
    Telemetry.BUFFER_FLUSH_INTERVAL_MS = 5000 // 5 seconds
    ;
})();
(()=>{
    Telemetry.MAX_BUFFER_SIZE = 1000 // Max 1000 metrics in buffer
    ;
})();
const telemetry = new Telemetry();
